import Kinematics2 from '../../Images/KinematicsImg.png'

const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Shared arrow marker defs component ───────────────────────────
function Defs() {
  return (
    <defs>
      <marker id="aRed"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#c0392b"/></marker>
      <marker id="aBlue" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#2E75B6"/></marker>
      <marker id="aGrn"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#27ae60"/></marker>
      <marker id="aOrg"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#e07b00"/></marker>
      <marker id="aPur"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#9b59b6"/></marker>
      <marker id="aGry"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#555"/></marker>
    </defs>
  );
}

// ── Diagram 1: Displacement, Velocity, Acceleration — 1D plots ───
function DiagDVA() {
  const W=900, H=400;
  // x(t) = 2sin(t) + 0.5t  (combined oscillation + drift)
  // v(t) = 2cos(t) + 0.5
  // a(t) = -2sin(t)
  const dt=0.02, tMax=4*Math.PI;
  const ptX=[], ptV=[], ptA=[];
  for(let t=0;t<=tMax;t+=dt){
    ptX.push([t, 2*Math.sin(t)+0.5*t]);
    ptV.push([t, 2*Math.cos(t)+0.5]);
    ptA.push([t, -2*Math.sin(t)]);
  }

  const panH=88, gap=12, y0=20;
  const panels=[
    {pts:ptX, color:'#2E75B6', label:'x(t) — Displacement', yMin:-1, yMax:8,  unit:'m'},
    {pts:ptV, color:'#27ae60', label:'v(t) = ẋ  — Velocity',  yMin:-2, yMax:4,  unit:'m/s'},
    {pts:ptA, color:'#c0392b', label:'a(t) = ẍ  — Acceleration', yMin:-3, yMax:3, unit:'m/s²'},
  ];

  const mx = t => 52+(t/tMax)*480;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Displacement, Velocity &amp; Acceleration — Calculus Relationships</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* Three stacked waveform strips */}
        {panels.map(({pts,color,label,yMin,yMax,unit},pi) => {
          const yOff = y0 + pi*(panH+gap);
          const yRange = yMax-yMin;
          const my = y => yOff+panH - ((y-yMin)/yRange)*panH;
          const pathD = pts.map(([t,y],i)=>`${i===0?'M':'L'}${mx(t).toFixed(1)},${my(y).toFixed(1)}`).join(' ');
          const zeroY = my(0);

          return (
            <g key={pi}>
              <rect x={50} y={yOff} width={484} height={panH} rx={3} fill="#fafafa" stroke="#e8d0d0"/>
              {/* zero line */}
              {yMin<0 && <line x1={50} y1={zeroY} x2={534} y2={zeroY} stroke="#ddd" strokeWidth="1" strokeDasharray="4,3"/>}
              {/* curve */}
              <path d={pathD} fill="none" stroke={color} strokeWidth="2.5"/>
              {/* label */}
              <text x={56} y={yOff+14} fontSize="12" fill={color} fontWeight="700">{label}</text>
              {/* y-axis ticks */}
              {[yMin,0,yMax].filter((v,i,a)=>a.indexOf(v)===i).map(v=>(
                <g key={v}>
                  <line x1={46} y1={my(v)} x2={50} y2={my(v)} stroke="#aaa" strokeWidth="1.5"/>
                  <text x={43} y={my(v)+4} textAnchor="end" fontSize="9" fill="#888">{v}</text>
                </g>
              ))}
              <text x={36} y={yOff+panH/2+4} textAnchor="middle" fontSize="10" fill={color} transform={`rotate(-90,36,${yOff+panH/2})`}>{unit}</text>
            </g>
          );
        })}

        {/* shared time axis */}
        {[0,Math.PI,2*Math.PI,3*Math.PI,4*Math.PI].map(t=>(
          <g key={t}>
            <line x1={mx(t)} y1={y0+3*(panH+gap)} x2={mx(t)} y2={y0+3*(panH+gap)+6} stroke="#555" strokeWidth="1.5"/>
            <text x={mx(t)} y={y0+3*(panH+gap)+17} textAnchor="middle" fontSize="10" fill="#555">{t===0?'0':t===Math.PI?'π':t===2*Math.PI?'2π':t===3*Math.PI?'3π':'4π'}</text>
          </g>
        ))}
        <line x1={50} y1={y0+3*(panH+gap)+4} x2={538} y2={y0+3*(panH+gap)+4} stroke="#555" strokeWidth="1.5" markerEnd="url(#aGry)"/>
        <text x={542} y={y0+3*(panH+gap)+8} fontSize="11" fill="#555">t (s)</text>

        {/* Derivative arrows between panels */}
        {[0,1].map(i=>{
          const yFrom = y0+i*(panH+gap)+panH+4;
          const yTo   = y0+(i+1)*(panH+gap)-4;
          return (
            <g key={i}>
              <line x1={555} y1={yFrom} x2={555} y2={yTo} stroke="#9b59b6" strokeWidth="2" markerEnd="url(#aPur)"/>
              <rect x={558} y={(yFrom+yTo)/2-10} width={62} height={20} rx={3} fill="#f5d0ff" stroke="#9b59b6" strokeWidth="1"/>
              <text x={589} y={(yFrom+yTo)/2+4} textAnchor="middle" fontSize="11" fill="#9b59b6" fontWeight="700">d/dt</text>
            </g>
          );
        })}
        {/* Integral arrows (reversed) */}
        {[1,0].map(i=>{
          const yFrom = y0+(i+1)*(panH+gap)-4;
          const yTo   = y0+i*(panH+gap)+panH+4;
          return (
            <g key={i}>
              <line x1={640} y1={yFrom} x2={640} y2={yTo} stroke="#27ae60" strokeWidth="2" markerEnd="url(#aGrn)"/>
              <rect x={643} y={(yFrom+yTo)/2-10} width={60} height={20} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
              <text x={673} y={(yFrom+yTo)/2+4} textAnchor="middle" fontSize="11" fill="#27ae60" fontWeight="700">∫ dt</text>
            </g>
          );
        })}

        {/* Right: formula panel */}
        <rect x={720} y={10} width={172} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={806} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Relationships</text>
        {[
          {y:38,  bg:'#eaf3ff', bc:'#2E75B6', lines:['Velocity:','v = dx/dt = ẋ','= lim Δx/Δt as Δt→0']},
          {y:100, bg:'#f0fff4', bc:'#27ae60', lines:['Acceleration:','a = dv/dt = ẍ','= d²x/dt²']},
          {y:162, bg:'#FEF0F0', bc:'#c0392b', lines:['Integrate back:','x = ∫v dt + x₀','v = ∫a dt + v₀']},
          {y:224, bg:'#fff5e6', bc:'#e07b00', lines:['SUVAT (const a):','v = u + at','s = ut + ½at²','v² = u² + 2as']},
          {y:316, bg:'#f5d0ff', bc:'#9b59b6', lines:['Jerk:','j = da/dt = d³x/dt³','Relevant for ride comfort,','robot motion planning']},
        ].map(({y,bg,bc,lines})=>(
          <g key={y}>
            <rect x={726} y={y} width={160} height={lines.length*17+10} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            {lines.map((l,i)=><text key={i} x={730} y={y+16+i*17} fontSize="10" fill={i===0?'#7B0D0D':'#333'} fontWeight={i===0?'700':'400'} fontFamily={i>0?"'Courier New',monospace":'inherit'}>{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Displacement x(t), velocity v = dx/dt, and acceleration a = dv/dt are linked by differentiation (going down) and integration (going up). Velocity is the slope of the displacement curve at any instant; acceleration is the slope of the velocity curve. These three quantities fully describe 1-D motion of a particle. Here x(t) = 2sin(t) + 0.5t illustrates how a combined oscillation and drift looks different at each level.
      </div>
    </div>
  );
}

// ── Diagram 2: Curvilinear Motion — Cartesian, Polar, Normal-Tangential ──
function DiagCurvilinear() {
  const W=900, H=380;
  // A circular arc trajectory for illustration
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Curvilinear Motion — Three Coordinate Systems</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* ── Panel 1: Cartesian (x-y) ─── */}
        <rect x={10} y={10} width={270} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={145} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Cartesian  (x, y)</text>

        {/* Axes */}
        <line x1={40} y1={300} x2={258} y2={300} stroke="#555" strokeWidth="1.5" markerEnd="url(#aGry)"/>
        <line x1={40} y1={300} x2={40}  y2={60}  stroke="#555" strokeWidth="1.5" markerEnd="url(#aGry)"/>
        <text x={264} y={304} fontSize="12" fill="#555">x</text>
        <text x={32}  y={57}  fontSize="12" fill="#555">y</text>

        {/* Parabolic trajectory */}
        {(() => {
          const pts=[];
          for(let x=0;x<=200;x+=2){const y=x*x/200;pts.push([40+x, 300-y]);}
          return <path d={pts.map((p,i)=>`${i===0?'M':'L'}${p[0]},${p[1]}`).join(' ')} fill="none" stroke="#9b59b6" strokeWidth="2.5"/>;
        })()}

        {/* Point P at x=120 */}
        {(() => {
          const px=160, py=300-120*120/200;
          return (
            <>
              <circle cx={px} cy={py} r={5} fill="#c0392b" stroke="#fff" strokeWidth="1.5"/>
              <text x={px+7} y={py-5} fontSize="12" fill="#c0392b" fontWeight="700">P</text>
              {/* r vector */}
              <line x1={40} y1={300} x2={px} y2={py} stroke="#2E75B6" strokeWidth="2" strokeDasharray="5,3" markerEnd="url(#aBlue)"/>
              <text x={95} y={270} fontSize="11" fill="#2E75B6" fontWeight="700">r</text>
              {/* vx */}
              <line x1={px} y1={py} x2={px+38} y2={py} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#aGrn)"/>
              <text x={px+42} y={py+4} fontSize="11" fill="#27ae60" fontWeight="700">vₓ</text>
              {/* vy */}
              <line x1={px} y1={py} x2={px} y2={py-38} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#aRed)"/>
              <text x={px+5} y={py-42} fontSize="11" fill="#c0392b" fontWeight="700">vy</text>
            </>
          );
        })()}

        <rect x={16} y={295} width={258} height={72} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1"/>
        <text x={22} y={311} fontSize="11" fill="#7B0D0D" fontWeight="700">v = vₓî + vyĵ</text>
        <text x={22} y={327} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">vₓ = ẋ,  vy = ẏ</text>
        <text x={22} y={343} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">aₓ = ẍ,  ay = ÿ</text>
        <text x={22} y={359} fontSize="11" fill="#555">Components independent</text>

        {/* ── Panel 2: Polar (r, θ) ─── */}
        <rect x={290} y={10} width={290} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={435} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Polar  (r, θ)</text>

        {/* Origin */}
        <circle cx={370} cy={220} r={4} fill="#555"/>
        <text x={363} y={236} fontSize="11" fill="#555">O</text>

        {/* r vector */}
        {(() => {
          const ang=-0.6, R=130;
          const px=370+R*Math.cos(ang), py=220+R*Math.sin(ang);
          const eRx=Math.cos(ang), eRy=Math.sin(ang);
          const eTx=-Math.sin(ang), eTy=Math.cos(ang);

          return (
            <>
              {/* Reference line */}
              <line x1={370} y1={220} x2={370+150} y2={220} stroke="#aaa" strokeWidth="1.2" strokeDasharray="5,3"/>
              {/* r vector */}
              <line x1={370} y1={220} x2={px} y2={py} stroke="#2E75B6" strokeWidth="2.5" markerEnd="url(#aBlue)"/>
              <text x={(370+px)/2-14} y={(220+py)/2-8} fontSize="12" fill="#2E75B6" fontWeight="700">r</text>
              {/* θ arc */}
              <path d={`M ${370+50},${220} A 50,50 0 0 ${ang<0?0:1} ${370+50*Math.cos(ang)},${220+50*Math.sin(ang)}`} fill="none" stroke="#e07b00" strokeWidth="1.8"/>
              <text x={370+58} y={213} fontSize="12" fill="#e07b00" fontWeight="700">θ</text>
              {/* Point P */}
              <circle cx={px} cy={py} r={6} fill="#c0392b" stroke="#fff" strokeWidth="1.5"/>
              <text x={px+8} y={py-6} fontSize="12" fill="#c0392b" fontWeight="700">P</text>
              {/* eR unit vector */}
              <line x1={px} y1={py} x2={px+40*eRx} y2={py+40*eRy} stroke="#2E75B6" strokeWidth="2" markerEnd="url(#aBlue)"/>
              <text x={px+44*eRx} y={py+44*eRy+4} fontSize="11" fill="#2E75B6" fontWeight="700">êᵣ</text>
              {/* eTheta unit vector */}
              <line x1={px} y1={py} x2={px+40*eTx} y2={py+40*eTy} stroke="#c0392b" strokeWidth="2" markerEnd="url(#aRed)"/>
              <text x={px+44*eTx-4} y={py+44*eTy-6} fontSize="11" fill="#c0392b" fontWeight="700">êθ</text>
              {/* Velocity v = ṙêᵣ + rθ̇êθ */}
              <line x1={px} y1={py} x2={px+28*eRx+32*eTx} y2={py+28*eRy+32*eTy} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#aGrn)"/>
              <text x={px+28*eRx+32*eTx+6} y={py+28*eRy+32*eTy} fontSize="11" fill="#27ae60" fontWeight="700">v</text>
            </>
          );
        })()}

        <rect x={296} y={295} width={278} height={72} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={302} y={311} fontSize="11" fill="#7B0D0D" fontWeight="700">v = ṙêᵣ + rθ̇ êθ</text>
        <text x={302} y={327} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">a = (r̈−rθ̇²)êᵣ + (rθ̈+2ṙθ̇)êθ</text>
        <text x={302} y={343} fontSize="11" fill="#555">Centripetal: −rθ̇²êᵣ  (inward)</text>
        <text x={302} y={359} fontSize="11" fill="#555">Coriolis:   2ṙθ̇êθ (if ṙ≠0)</text>

        {/* ── Panel 3: Normal-Tangential (n, t) ─── */}
        <rect x={600} y={10} width={290} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={745} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Normal-Tangential  (n, t)</text>

        {/* Curved path */}
        {(() => {
          const pathPts=[];
          for(let t=0.3;t<=2.5;t+=0.04){pathPts.push([620+t*90,220-60*Math.sin(t+0.3)]);}
          const d=pathPts.map((p,i)=>`${i===0?'M':'L'}${p[0]},${p[1]}`).join(' ');
          // Point near middle, t=1.4
          const ti=1.4, px=620+ti*90, py=220-60*Math.sin(ti+0.3);
          const dxdt=90, dydt=-60*Math.cos(ti+0.3);
          const spd=Math.sqrt(dxdt*dxdt+dydt*dydt);
          const tx=dxdt/spd, ty=dydt/spd;  // unit tangent
          const nx=-ty, ny=tx;  // unit normal (pointing inward = to center of curvature)
          const ρ=140; // approx radius of curvature

          return (
            <>
              <path d={d} fill="none" stroke="#9b59b6" strokeWidth="2.5"/>
              <circle cx={px} cy={py} r={6} fill="#c0392b" stroke="#fff" strokeWidth="1.5"/>
              <text x={px+8} y={py-6} fontSize="12" fill="#c0392b" fontWeight="700">P</text>
              {/* êt */}
              <line x1={px} y1={py} x2={px+46*tx} y2={py+46*ty} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#aGrn)"/>
              <text x={px+50*tx+4} y={py+50*ty+4} fontSize="12" fill="#27ae60" fontWeight="700">êₜ</text>
              {/* ên */}
              <line x1={px} y1={py} x2={px+46*nx} y2={py+46*ny} stroke="#2E75B6" strokeWidth="2.5" markerEnd="url(#aBlue)"/>
              <text x={px+50*nx} y={py+50*ny-6} fontSize="12" fill="#2E75B6" fontWeight="700">êₙ</text>
              {/* velocity v = v êt */}
              <line x1={px} y1={py} x2={px+70*tx} y2={py+70*ty} stroke="#c0392b" strokeWidth="2" markerEnd="url(#aRed)"/>
              <text x={px+74*tx+4} y={py+74*ty} fontSize="12" fill="#c0392b" fontWeight="700">v = vêₜ</text>
              {/* radius of curvature arc */}
              <path d={`M ${px+nx*ρ},${py+ny*ρ} A ${ρ},${ρ} 0 0 0 ${px+42*nx+40*tx},${py+42*ny+40*ty}`} fill="none" stroke="#e07b00" strokeWidth="1.5" strokeDasharray="5,3"/>
              <text x={px+nx*ρ/2+15} y={py+ny*ρ/2+40} fontSize="11" fill="#e07b00" fontWeight="700">ρ</text>
            </>
          );
        })()}

        <rect x={606} y={295} width={278} height={72} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={612} y={311} fontSize="11" fill="#7B0D0D" fontWeight="700">v = v êₜ</text>
        <text x={612} y={327} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">a = v̇ êₜ + (v²/ρ) êₙ</text>
        <text x={612} y={343} fontSize="11" fill="#555">Tangential: v̇ (changes speed)</text>
        <text x={612} y={359} fontSize="11" fill="#555">Normal: v²/ρ (changes direction)</text>
      </svg>
      <div style={S.dCaption}>
        Three coordinate systems for particle kinematics. Cartesian (x,y): independent components, easiest algebra. Polar (r,θ): natural for rotation and orbital problems; Coriolis term 2ṙθ̇ appears when r changes while rotating. Normal-tangential (n,t): naturally separates speed change (tangential) from direction change (normal); ρ is the radius of curvature of the path at that point.
      </div>
    </div>
  );
}

// ── Diagram 3: Rigid Body — Translation, Rotation, General Motion ─
function DiagRigidBody() {
  const W=900, H=390;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Rigid Body Kinematics — Translation, Rotation &amp; General Planar Motion</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* ── Panel 1: Pure Translation ─── */}
        <rect x={10} y={10} width={270} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={145} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Pure Translation</text>

        {/* Body at two positions */}
        {[0,1].map(step=>{
          const dx=step*90;
          return (
            <g key={step} opacity={step===0?0.35:1}>
              <rect x={40+dx} y={120} width={100} height={60} rx={6} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
              <circle cx={60+dx} cy={140} r={5} fill="#fff"/>
              <circle cx={120+dx} cy={140} r={5} fill="#fff"/>
              <circle cx={60+dx} cy={165} r={5} fill="#fff"/>
              <circle cx={120+dx} cy={165} r={5} fill="#fff"/>
            </g>
          );
        })}

        {/* Velocity arrows — same for all points */}
        {[[65,135],[125,135],[65,162],[125,162]].map(([x,y],i)=>(
          <line key={i} x1={x+90} y1={y} x2={x+90+35} y2={y} stroke="#c0392b" strokeWidth="2" markerEnd="url(#aRed)"/>
        ))}
        <text x={215} y={150} fontSize="12" fill="#c0392b" fontWeight="700">v</text>
        <text x={215} y={165} fontSize="11" fill="#c0392b">same</text>

        {/* path arrows for two points */}
        <line x1={65} y1={145} x2={152} y2={145} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="5,3" markerEnd="url(#aBlue)"/>
        <line x1={65} y1={168} x2={152} y2={168} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="5,3" markerEnd="url(#aBlue)"/>

        <rect x={16} y={215} width={258} height={60} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1"/>
        <text x={22} y={232} fontSize="12" fill="#7B0D0D" fontWeight="700">All points: same v and a</text>
        <text x={22} y={250} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">vA = vB = vG  (any point)</text>
        <text x={22} y={266} fontSize="11" fill="#444">No rotation: θ̇ = 0, θ̈ = 0</text>

        {/* EOM box */}
        <rect x={16} y={282} width={258} height={88} rx={3} fill="#f5d0ff" stroke="#9b59b6" strokeWidth="1"/>
        <text x={22} y={298} fontSize="11" fill="#7B0D0D" fontWeight="700">Equations of Motion:</text>
        <text x={22} y={314} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">ΣFx = maGx</text>
        <text x={22} y={330} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">ΣFy = maGy</text>
        <text x={22} y={346} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">ΣMG = 0  (pure trans.)</text>
        <text x={22} y={362} fontSize="11" fill="#555" fontStyle="italic">Torque about G = 0</text>

        {/* ── Panel 2: Pure Rotation ─── */}
        <rect x={295} y={10} width={270} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={430} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Pure Rotation about Fixed O</text>

        {/* Fixed pivot */}
        <circle cx={430} cy={180} r={8} fill="#555" stroke="#333" strokeWidth="2"/>
        <text x={438} y={196} fontSize="11" fill="#555" fontWeight="700">O (fixed)</text>

        {/* Rotating rod */}
        {(() => {
          const ang=-0.5, R=100;
          const px=430+R*Math.cos(ang), py=180+R*Math.sin(ang);
          const vTan=50; const vtx=-Math.sin(ang)*vTan, vty=Math.cos(ang)*vTan;
          const acN=35; const anx=-Math.cos(ang)*acN, any=-Math.sin(ang)*acN;
          const acT=25; const atx=-Math.sin(ang)*acT, aty=Math.cos(ang)*acT;

          return (
            <>
              {/* Previous position (ghost) */}
              {(() => {
                const ang2=0.15;
                return <line x1={430} y1={180} x2={430+R*Math.cos(ang2)} y2={180+R*Math.sin(ang2)} stroke="#2E75B6" strokeWidth="3" strokeDasharray="6,4" opacity="0.35"/>;
              })()}
              {/* Rod */}
              <line x1={430} y1={180} x2={px} y2={py} stroke="#2E75B6" strokeWidth="3.5"/>
              {/* θ arc */}
              <path d={`M ${430+55},${180} A 55,55 0 0 0 ${430+55*Math.cos(ang)},${180+55*Math.sin(ang)}`} fill="none" stroke="#e07b00" strokeWidth="1.8"/>
              <text x={430+62} y={178} fontSize="12" fill="#e07b00" fontWeight="700">θ</text>
              {/* Point P */}
              <circle cx={px} cy={py} r={7} fill="#c0392b" stroke="#fff" strokeWidth="2"/>
              <text x={px+10} y={py-4} fontSize="12" fill="#c0392b" fontWeight="700">P</text>
              {/* r label */}
              <text x={(430+px)/2-18} y={(180+py)/2+4} fontSize="12" fill="#2E75B6" fontWeight="700">r</text>
              {/* v_tangential */}
              <line x1={px} y1={py} x2={px+vtx} y2={py+vty} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#aGrn)"/>
              <text x={px+vtx+6} y={py+vty} fontSize="11" fill="#27ae60" fontWeight="700">v=rθ̇</text>
              {/* a_normal (centripetal) */}
              <line x1={px} y1={py} x2={px+anx} y2={py+any} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#aRed)"/>
              <text x={px+anx-4} y={py+any-8} fontSize="10" fill="#c0392b" fontWeight="700">aₙ=rθ̇²</text>
              {/* a_tangential */}
              <line x1={px} y1={py} x2={px+atx} y2={py+aty} stroke="#9b59b6" strokeWidth="2" markerEnd="url(#aPur)"/>
              <text x={px+atx+4} y={py+aty+12} fontSize="10" fill="#9b59b6" fontWeight="700">aₜ=rθ̈</text>
              {/* ω arc arrow */}
              <path d={`M ${430+75},${180} A 75,75 0 0 0 ${430+75*Math.cos(ang)},${180+75*Math.sin(ang)}`} fill="none" stroke="#c0392b" strokeWidth="2" markerEnd="url(#aRed)"/>
              <text x={430+82} y={170} fontSize="12" fill="#c0392b" fontWeight="700">ω</text>
            </>
          );
        })()}

        <rect x={301} y={295} width={258} height={84} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={307} y={311} fontSize="11" fill="#7B0D0D" fontWeight="700">Point P at radius r from O:</text>
        <text x={307} y={327} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">v = rω = rθ̇</text>
        <text x={307} y={343} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">aₙ = rω² = v²/r  (centripetal)</text>
        <text x={307} y={359} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">aₜ = rα = rθ̈  (tangential)</text>
        <text x={307} y={375} fontSize="11" fill="#555">|a| = r√(ω⁴+α²)</text>

        {/* ── Panel 3: General Planar Motion ─── */}
        <rect x={580} y={10} width={310} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={735} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">General Planar Motion</text>
        <text x={735} y={48} textAnchor="middle" fontSize="11" fill="#555" fontStyle="italic">Translation of G + Rotation about G</text>

        {/* Rolling wheel illustration */}
        {(() => {
          const cx=710, cy=200, R=70;
          const ang=-0.7; // rotation angle
          // Ground
          return (
            <>
              <line x1={595} y1={270} x2={870} y2={270} stroke="#555" strokeWidth="2"/>
              {[595,617,639,661,683,705,727,749,771,793,815,837,859].map(x=>(<line key={x} x1={x} y1={270} x2={x-12} y2={286} stroke="#555" strokeWidth="1.5"/>))}

              {/* Wheel */}
              <circle cx={cx} cy={cy} r={R} fill="#f0f0f0" stroke="#888" strokeWidth="2"/>
              <circle cx={cx} cy={cy} r={6} fill="#555"/>
              {/* Spokes */}
              {[0,60,120,180,240,300].map(d=>{
                const rd=d*Math.PI/180+ang;
                return <line key={d} x1={cx} y1={cy} x2={cx+(R-6)*Math.cos(rd)} y2={cy+(R-6)*Math.sin(rd)} stroke="#aaa" strokeWidth="1.5"/>;
              })}

              {/* G label */}
              <text x={cx+9} y={cy+4} fontSize="12" fill="#555" fontWeight="700">G</text>

              {/* vG — horizontal */}
              <line x1={cx} y1={cy} x2={cx+55} y2={cy} stroke="#2E75B6" strokeWidth="2.5" markerEnd="url(#aBlue)"/>
              <text x={cx+58} y={cy+4} fontSize="12" fill="#2E75B6" fontWeight="700">vG</text>

              {/* ω (CCW arc) */}
              <path d={`M ${cx+40},${cy} A 40,40 0 0 1 ${cx},${cy-40}`} fill="none" stroke="#c0392b" strokeWidth="2" markerEnd="url(#aRed)"/>
              <text x={cx+46} y={cy-20} fontSize="12" fill="#c0392b" fontWeight="700">ω</text>

              {/* Point A at top of wheel */}
              {(() => {
                const ax=cx+R*Math.cos(ang-Math.PI/2), ay=cy+R*Math.sin(ang-Math.PI/2);
                const rax=ax-cx, ray=ay-cy;
                const vax=-ray*(-1), vay=rax*(-1); // ω×r, ω=1 for illustration, CCW so negate
                // vA = vG + ω×rA/G
                const vAx=55+(-ray), vAy=rax;  // sum
                return (
                  <>
                    <circle cx={ax} cy={ay} r={5} fill="#27ae60" stroke="#fff" strokeWidth="1.5"/>
                    <text x={ax-14} y={ay-8} fontSize="11" fill="#27ae60" fontWeight="700">A</text>
                    <line x1={ax} y1={ay} x2={ax+vAx*0.6} y2={ay+vAy*0.6} stroke="#27ae60" strokeWidth="2" markerEnd="url(#aGrn)"/>
                  </>
                );
              })()}

              {/* Contact point C at bottom */}
              <circle cx={cx} cy={270} r={5} fill="#e07b00" stroke="#fff" strokeWidth="1.5"/>
              <text x={cx-14} y={285} fontSize="11" fill="#e07b00" fontWeight="700">C</text>
              <text x={cx-22} y={262} fontSize="11" fill="#e07b00">v=0</text>
            </>
          );
        })()}

        <rect x={586} y={295} width={298} height={84} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={592} y={311} fontSize="11" fill="#7B0D0D" fontWeight="700">Velocity of any point B on body:</text>
        <text x={592} y={327} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">vB = vG + ω × rB/G</text>
        <text x={592} y={343} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">aB = aG + α×rB/G − ω²rB/G</text>
        <text x={592} y={359} fontSize="11" fill="#555">Rolling without slip: vG = Rω</text>
        <text x={592} y={375} fontSize="11" fill="#555">Contact point C: vC = 0</text>
      </svg>
      <div style={S.dCaption}>
        Rigid body planar motion decomposes into translation of the centre of mass G and rotation about G. Pure translation: all points share the same velocity and acceleration. Pure rotation: velocity is tangential (perpendicular to radius), acceleration has centripetal (−rω²) and tangential (rα) components. General motion combines both. For a wheel rolling without slip, the contact point has zero velocity and vG = Rω.
      </div>
    </div>
  );
}

// ── Diagram 4: Angular Velocity & Acceleration — Rotation Kinematics ──
function DiagAngularKinematics() {
  const W=900, H=320;
  // θ(t) = 2sin(t) + 0.4t²  => ω = 2cos(t)+0.8t  => α = -2sin(t)+0.8
  const dt=0.02, tMax=2*Math.PI;
  const ptTh=[], ptOm=[], ptAl=[];
  for(let t=0;t<=tMax;t+=dt){
    ptTh.push([t, 2*Math.sin(t)+0.4*t*t]);
    ptOm.push([t, 2*Math.cos(t)+0.8*t]);
    ptAl.push([t, -2*Math.sin(t)+0.8]);
  }

  const panH=72, gap=10, y0=18;
  const panels=[
    {pts:ptTh,color:'#2E75B6',label:'θ(t) — Angular Displacement (rad)', yMin:0,  yMax:10},
    {pts:ptOm,color:'#27ae60',label:'ω(t) = θ̇ — Angular Velocity (rad/s)',yMin:-2, yMax:8},
    {pts:ptAl,color:'#c0392b',label:'α(t) = θ̈ — Angular Acceleration (rad/s²)',yMin:-2,yMax:3},
  ];
  const mx = t => 52+(t/tMax)*470;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Angular Kinematics — θ, ω, α and Their Calculus Relationships</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {panels.map(({pts,color,label,yMin,yMax},pi) => {
          const yOff=y0+pi*(panH+gap);
          const yRange=yMax-yMin;
          const my=y=>yOff+panH-((y-yMin)/yRange)*panH;
          const zeroY=my(0);
          const pathD=pts.map(([t,y],i)=>`${i===0?'M':'L'}${mx(t).toFixed(1)},${my(y).toFixed(1)}`).join(' ');

          return (
            <g key={pi}>
              <rect x={50} y={yOff} width={475} height={panH} rx={3} fill="#fafafa" stroke="#e8d0d0"/>
              {yMin<0 && <line x1={50} y1={zeroY} x2={527} y2={zeroY} stroke="#ddd" strokeWidth="1" strokeDasharray="4,3"/>}
              <path d={pathD} fill="none" stroke={color} strokeWidth="2.5"/>
              <text x={56} y={yOff+13} fontSize="11" fill={color} fontWeight="700">{label}</text>
              {[yMin,0,yMax].filter((v,_,a)=>a.indexOf(v)===a.lastIndexOf(v)||v===0).map(v=>(
                <g key={v}>
                  <line x1={46} y1={my(v)} x2={50} y2={my(v)} stroke="#aaa" strokeWidth="1.5"/>
                  <text x={43} y={my(v)+4} textAnchor="end" fontSize="9" fill="#888">{v}</text>
                </g>
              ))}
            </g>
          );
        })}

        {/* Time axis */}
        <line x1={50} y1={y0+3*(panH+gap)+4} x2={528} y2={y0+3*(panH+gap)+4} stroke="#555" strokeWidth="1.5" markerEnd="url(#aGry)"/>
        {[0,Math.PI/2,Math.PI,3*Math.PI/2,2*Math.PI].map(t=>(
          <g key={t}>
            <line x1={mx(t)} y1={y0+3*(panH+gap)+1} x2={mx(t)} y2={y0+3*(panH+gap)+7} stroke="#555" strokeWidth="1.5"/>
            <text x={mx(t)} y={y0+3*(panH+gap)+17} textAnchor="middle" fontSize="9" fill="#555">{['0','π/2','π','3π/2','2π'][Math.round(t/(Math.PI/2))]}</text>
          </g>
        ))}

        {/* d/dt arrows */}
        {[0,1].map(i=>{
          const yf=y0+i*(panH+gap)+panH+4, yt=y0+(i+1)*(panH+gap)-4;
          return (
            <g key={i}>
              <line x1={548} y1={yf} x2={548} y2={yt} stroke="#9b59b6" strokeWidth="2" markerEnd="url(#aPur)"/>
              <rect x={551} y={(yf+yt)/2-9} width={56} height={18} rx={3} fill="#f5d0ff" stroke="#9b59b6" strokeWidth="1"/>
              <text x={579} y={(yf+yt)/2+5} textAnchor="middle" fontSize="10" fill="#9b59b6" fontWeight="700">d/dt</text>
            </g>
          );
        })}

        {/* Right panel */}
        <rect x={614} y={10} width={278} height={H-15} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={753} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Angular Kinematic Equations</text>

        {[
          {y:36,  bg:'#eaf3ff', bc:'#2E75B6', lines:['Definitions:','ω = dθ/dt  [rad/s]','α = dω/dt = d²θ/dt²  [rad/s²]']},
          {y:104, bg:'#f0fff4', bc:'#27ae60', lines:['Constant α (SUVAT analog):','ω = ω₀ + αt','θ = θ₀ + ω₀t + ½αt²','ω² = ω₀² + 2α(θ−θ₀)']},
          {y:186, bg:'#FEF0F0', bc:'#c0392b', lines:['Link to linear (radius r):','s = rθ   (arc length)','v = rω   (tangential speed)','a_t = rα  (tangential accel.)','a_n = rω² = v²/r  (centripetal)']},
          {y:286, bg:'#fff5e6', bc:'#e07b00', lines:['Vector form (3D):','ω = θ̇ k̂  (z-axis rotation)','v = ω × r  (cross product)','a = α×r − ω²r']},
        ].map(({y,bg,bc,lines})=>(
          <g key={y}>
            <rect x={620} y={y} width={266} height={lines.length*17+8} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            {lines.map((l,i)=><text key={i} x={626} y={y+16+i*17} fontSize="10" fill={i===0?'#7B0D0D':'#333'} fontWeight={i===0?'700':'400'} fontFamily={i>0?"'Courier New',monospace":'inherit'}>{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Angular kinematics mirrors linear kinematics exactly: θ ↔ x, ω ↔ v, α ↔ a. The same SUVAT equations apply for constant angular acceleration. The critical link to linear motion is through the radius: v = rω and aₜ = rα connect rotational and translational quantities, while the centripetal acceleration aₙ = rω² always points inward toward the centre of rotation.
      </div>
    </div>
  );
}

// ── Diagram 5: Relative Motion — Two Points on a Rigid Body ───────
function DiagRelativeMotion() {
  const W=900, H=400;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Relative Motion — Velocity &amp; Acceleration of Point B Relative to A</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* ── LEFT: velocity diagram ─────────────── */}
        <rect x={10} y={10} width={415} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={217} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Velocity Diagram</text>

        {/* Rigid body (link) */}
        {(() => {
          const ax=90, ay=200, bx=300, by=140;
          const dx=bx-ax, dy=by-ay, L=Math.sqrt(dx*dx+dy*dy);
          const ux=dx/L, uy=dy/L;
          const perp_x=-uy, perp_y=ux;

          // vA (given)
          const vAx=50, vAy=-15;
          // omega (CCW)
          const ω=1, rABx=dx, rABy=dy;
          // ω × rAB = ω*k × rAB  = ω(-rABy, rABx) for CCW (+z)
          const vBA_x=-ω*rABy*0.25, vBA_y=ω*rABx*0.25;
          const vBx=vAx+vBA_x, vBy=vAy+vBA_y;

          return (
            <>
              {/* Body */}
              <line x1={ax} y1={ay} x2={bx} y2={by} stroke="#888" strokeWidth="4" strokeLinecap="round"/>
              <circle cx={ax} cy={ay} r={8} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
              <circle cx={bx} cy={by} r={8} fill="#c0392b" stroke="#922b21" strokeWidth="2"/>
              <text x={ax-16} y={ay+4} fontSize="13" fill="#2E75B6" fontWeight="700">A</text>
              <text x={bx+10} y={by+4} fontSize="13" fill="#c0392b" fontWeight="700">B</text>

              {/* rAB vector */}
              <line x1={ax} y1={ay} x2={bx} y2={by} stroke="#555" strokeWidth="1.5" strokeDasharray="5,3"/>
              <text x={(ax+bx)/2+8} y={(ay+by)/2-8} fontSize="12" fill="#555" fontWeight="700">{"r\u1D2E\u1DA6\u2044\u1D2C"}</text>

              {/* ω arc */}
              <path d={`M ${(ax+bx)/2+18},${(ay+by)/2} A 20,20 0 1 0 ${(ax+bx)/2+14},${(ay+by)/2-18}`} fill="none" stroke="#9b59b6" strokeWidth="2" markerEnd="url(#aPur)"/>
              <text x={(ax+bx)/2+25} y={(ay+by)/2-12} fontSize="12" fill="#9b59b6" fontWeight="700">{"\u03C9"}</text>

              {/* vA */}
              <line x1={ax} y1={ay} x2={ax+vAx} y2={ay+vAy} stroke="#2E75B6" strokeWidth="3" markerEnd="url(#aBlue)"/>
              <text x={ax+vAx+6} y={ay+vAy+4} fontSize="13" fill="#2E75B6" fontWeight="700">vA</text>

              {/* vB/A (perpendicular to AB) */}
              <line x1={bx} y1={by} x2={bx+vBA_x} y2={by+vBA_y} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#aGrn)"/>
              <text x={bx+vBA_x+6} y={by+vBA_y-4} fontSize="12" fill="#27ae60" fontWeight="700">{"v\u1D2E\u1DA6\u2044\u1D2C = \u03C9\xD7r\u1D2E\u1DA6\u2044\u1D2C"}</text>

              {/* vB = vA + vB/A — constructed at B */}
              <line x1={bx} y1={by} x2={bx+vBx} y2={by+vBy} stroke="#c0392b" strokeWidth="3" markerEnd="url(#aRed)"/>
              <text x={bx+vBx+6} y={by+vBy} fontSize="13" fill="#c0392b" fontWeight="700">vB</text>

              {/* Vector triangle */}
              <text x={60} y={310} fontSize="13" fill="#1a1a2e" fontWeight="700">vB = vA + v(B/A)</text>
              <text x={60} y={330} fontSize="13" fill="#1a1a2e" fontFamily="'Courier New',monospace">{"vB = vA + \u03C9 \xD7 r(B/A)"}</text>
              <text x={60} y={350} fontSize="11" fill="#555">{"|\u1D63(B/A)| = \u03C9\xB7|r(B/A)|"}</text>
              <text x={60} y={368} fontSize="11" fill="#555">{"Direction of v(B/A) \u22A5 r(B/A)"}</text>
            </>
          );
        })()}

        {/* Formula box */}
        <rect x={16} y={280} width={403} height={108} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.5"/>
        <text x={22} y={298} fontSize="13" fill="#7B0D0D" fontWeight="700">{"vB = vA + \u03C9 \xD7 r(B/A)"}</text>
        <text x={22} y={316} fontSize="11" fill="#444">{"Scalar form (2D): vBx = vAx \u2212 \u03C9y(B/A)"}</text>
        <text x={22} y={332} fontSize="11" fill="#444">{"               vBy = vAy + \u03C9x(B/A)"}</text>
        <text x={22} y={350} fontSize="11" fill="#555">{"v(B/A) is always \u22A5 to the line AB"}</text>
        <text x={22} y={368} fontSize="11" fill="#555">{"|\u1D63(B/A)| = \u03C9 \xD7 r  (r = length of AB)"}</text>
        <text x={22} y={380} fontSize="11" fill="#555">Two unknowns max — need 2 equations</text>

        {/* ── RIGHT: acceleration diagram ─────── */}
        <rect x={440} y={10} width={450} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={665} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Acceleration Diagram</text>

        {(() => {
          const ax=510, ay=190, bx=730, by=130;
          const dx=bx-ax, dy=by-ay;
          const ω=1, α=0.6;

          // aA (given)
          const aAx=-20, aAy=-30;
          // a(B/A) = α×r − ω²r  (tangential + centripetal)
          const aBAt_x=-α*dy*0.2, aBAt_y=α*dx*0.2;  // tangential: α×r
          const aBAn_x=-ω*ω*dx*0.12, aBAn_y=-ω*ω*dy*0.12;  // centripetal: -ω²r (towards A)

          return (
            <>
              {/* Body */}
              <line x1={ax} y1={ay} x2={bx} y2={by} stroke="#888" strokeWidth="4" strokeLinecap="round"/>
              <circle cx={ax} cy={ay} r={8} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
              <circle cx={bx} cy={by} r={8} fill="#c0392b" stroke="#922b21" strokeWidth="2"/>
              <text x={ax-16} y={ay+4} fontSize="13" fill="#2E75B6" fontWeight="700">A</text>
              <text x={bx+10} y={by+4} fontSize="13" fill="#c0392b" fontWeight="700">B</text>

              {/* aA */}
              <line x1={ax} y1={ay} x2={ax+aAx} y2={ay+aAy} stroke="#2E75B6" strokeWidth="3" markerEnd="url(#aBlue)"/>
              <text x={ax+aAx-26} y={ay+aAy-6} fontSize="12" fill="#2E75B6" fontWeight="700">aA</text>

              {/* a(B/A) tangential */}
              <line x1={bx} y1={by} x2={bx+aBAt_x} y2={by+aBAt_y} stroke="#9b59b6" strokeWidth="2.5" markerEnd="url(#aPur)"/>
              <text x={bx+aBAt_x+5} y={by+aBAt_y+4} fontSize="10" fill="#9b59b6" fontWeight="700">{"a(B/A)\u209C = \u03B1\xD7r"}</text>

              {/* a(B/A) centripetal (normal) */}
              <line x1={bx} y1={by} x2={bx+aBAn_x} y2={by+aBAn_y} stroke="#e07b00" strokeWidth="2.5" markerEnd="url(#aOrg)"/>
              <text x={bx+aBAn_x-70} y={by+aBAn_y+12} fontSize="10" fill="#e07b00" fontWeight="700">{"a(B/A)\u207F = \u2212\u03C9\xB2r"}</text>

              {/* aB = aA + a(B/A) */}
              {(()=>{ const aBxv=aAx+aBAt_x+aBAn_x, aByv=aAy+aBAt_y+aBAn_y; return(<>
                <line x1={bx} y1={by} x2={bx+aBxv} y2={by+aByv} stroke="#c0392b" strokeWidth="3" markerEnd="url(#aRed)"/>
                <text x={bx+aBxv+5} y={by+aByv} fontSize="12" fill="#c0392b" fontWeight="700">aB</text>
              </>);})()}
            </>
          );
        })()}

        <rect x={446} y={280} width={438} height={108} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={452} y={298} fontSize="13" fill="#7B0D0D" fontWeight="700">{"aB = aA + (a(B/A))\u207F + (a(B/A))\u209C"}</text>
        <text x={452} y={316} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">{"aB = aA \u2212 \u03C9\xB2r(B/A) + \u03B1\xD7r(B/A)"}</text>
        <text x={452} y={334} fontSize="11" fill="#555">{"(a(B/A))\u207F = \u03C9\xB2\xB7r  toward A (centripetal)"}</text>
        <text x={452} y={350} fontSize="11" fill="#555">{"(a(B/A))\u209C = \u03B1\xB7r  \u22A5 AB (tangential)"}</text>
        <text x={452} y={368} fontSize="11" fill="#555">Normal component always known in magnitude</text>
        <text x={452} y={384} fontSize="11" fill="#555">Tangential component direction always perpendicular to AB</text>
      </svg>
      <div style={S.dCaption}>
        The velocity and acceleration of point B on a rigid body are found by adding the relative velocity/acceleration of B with respect to point A to the absolute motion of A. The relative velocity is always perpendicular to the line joining the two points. The relative acceleration has two components: the centripetal part (ω²r directed inward, always known) and the tangential part (αr perpendicular to the link, unknown if α is unknown).
      </div>
    </div>
  );
}

// ── Diagram 6: Instantaneous Centre of Rotation ───────────────────
function DiagInstantCentre() {
  const W=900, H=360;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Instantaneous Centre of Zero Velocity (IC) — Graphical Velocity Analysis</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* ── LEFT: IC method for a link ─── */}
        <rect x={10} y={10} width={400} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={210} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">IC Method — Velocity from IC</text>

        {(() => {
          const ax=80, ay=250, bx=320, by=200;
          const icx=380, icy=40; // IC above and to the right

          // vA direction: perpendicular to IC-A line
          const rICAx=ax-icx, rICAy=ay-icy;
          const rICA=Math.sqrt(rICAx*rICAx+rICAy*rICAy);
          const vAx_dir=-rICAy/rICA, vAy_dir=rICAx/rICA;
          const vAscale=50;

          // vB direction: perpendicular to IC-B line
          const rICBx=bx-icx, rICBy=by-icy;
          const rICB=Math.sqrt(rICBx*rICBx+rICBy*rICBy);
          const vBx_dir=-rICBy/rICB, vBy_dir=rICBx/rICB;
          const ω=0.5, vBscale=ω*rICB;

          return (
            <>
              {/* Ground points */}
              <circle cx={ax} cy={ay} r={8} fill="#555" stroke="#333" strokeWidth="2"/>
              <polygon points={`${ax-12},${ay+8} ${ax+12},${ay+8} ${ax},${ay-8}`} fill="#888"/>
              <line x1={ax-16} y1={ay+8} x2={ax+16} y2={ay+8} stroke="#888" strokeWidth="2"/>

              {/* Body link */}
              <line x1={ax} y1={ay} x2={bx} y2={by} stroke="#2E75B6" strokeWidth="5" strokeLinecap="round" opacity="0.9"/>
              <circle cx={bx} cy={by} r={8} fill="#c0392b" stroke="#922b21" strokeWidth="2"/>
              <text x={ax-18} y={ay-5} fontSize="13" fill="#555" fontWeight="700">A</text>
              <text x={bx+10} y={by+4} fontSize="13" fill="#c0392b" fontWeight="700">B</text>

              {/* Lines from A and B to IC */}
              <line x1={ax} y1={ay} x2={icx} y2={icy} stroke="#e07b00" strokeWidth="1.5" strokeDasharray="6,3"/>
              <line x1={bx} y1={by} x2={icx} y2={icy} stroke="#e07b00" strokeWidth="1.5" strokeDasharray="6,3"/>

              {/* IC point */}
              <circle cx={icx} cy={icy} r={8} fill="#e07b00" stroke="#b7510a" strokeWidth="2"/>
              <text x={icx+12} y={icy+4} fontSize="13" fill="#e07b00" fontWeight="700">IC</text>

              {/* rA and rB labels */}
              <text x={(ax+icx)/2-30} y={(ay+icy)/2} fontSize="11" fill="#e07b00" fontWeight="700">rA</text>
              <text x={(bx+icx)/2+4} y={(by+icy)/2} fontSize="11" fill="#e07b00" fontWeight="700">rB</text>

              {/* vA perpendicular */}
              <line x1={ax} y1={ay} x2={ax+vAx_dir*vAscale} y2={ay+vAy_dir*vAscale} stroke="#2E75B6" strokeWidth="3" markerEnd="url(#aBlue)"/>
              <text x={ax+vAx_dir*vAscale+5} y={ay+vAy_dir*vAscale+4} fontSize="13" fill="#2E75B6" fontWeight="700">vA</text>

              {/* vB perpendicular */}
              <line x1={bx} y1={by} x2={bx+vBx_dir*vBscale} y2={by+vBy_dir*vBscale} stroke="#c0392b" strokeWidth="3" markerEnd="url(#aRed)"/>
              <text x={bx+vBx_dir*vBscale+5} y={by+vBy_dir*vBscale} fontSize="13" fill="#c0392b" fontWeight="700">vB</text>

              {/* ω labels */}
              <text x={165} y={170} fontSize="12" fill="#9b59b6" fontWeight="700">vA = ω·rA</text>
              <text x={165} y={188} fontSize="12" fill="#9b59b6" fontWeight="700">vB = ω·rB</text>
              <text x={165} y={206} fontSize="11" fill="#555">vB/vA = rB/rA</text>
            </>
          );
        })()}

        <rect x={16} y={288} width={388} height={62} rx={3} fill="#fff5e6" stroke="#e07b00" strokeWidth="1.5"/>
        <text x={22} y={306} fontSize="12" fill="#7B0D0D" fontWeight="700">IC Method Rules:</text>
        <text x={22} y={322} fontSize="11" fill="#444">1. IC is where perpendiculars to vA and vB intersect</text>
        <text x={22} y={338} fontSize="11" fill="#444">2. v = ω × r  from IC to the point</text>
        <text x={22} y={354} fontSize="11" fill="#555" fontStyle="italic">IC changes position every instant (not fixed!)</text>

        {/* ── RIGHT: Special IC cases ────────────── */}
        <rect x={420} y={10} width={470} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={655} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Special Cases &amp; IC at Infinity</text>

        {/* Case 1: Rolling wheel */}
        <rect x={426} y={40} width={220} height={150} rx={4} fill="#fafafa" stroke="#f0cece"/>
        <text x={536} y={58} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Rolling Wheel</text>
        {(() => {
          const cx=536, cy=130, R=50;
          return (
            <>
              <circle cx={cx} cy={cy} r={R} fill="#f0f0f0" stroke="#888" strokeWidth="2"/>
              <circle cx={cx} cy={cy} r={5} fill="#555"/>
              {/* Ground */}
              <line x1={432} y1={180} x2={640} y2={180} stroke="#555" strokeWidth="2"/>
              {/* IC at contact point */}
              <circle cx={cx} cy={180} r={7} fill="#e07b00" stroke="#b7510a" strokeWidth="2"/>
              <text x={cx+10} y={186} fontSize="11" fill="#e07b00" fontWeight="700">IC</text>
              {/* vG */}
              <line x1={cx} y1={cy} x2={cx+38} y2={cy} stroke="#2E75B6" strokeWidth="2.5" markerEnd="url(#aBlue)"/>
              <text x={cx+42} y={cy+4} fontSize="11" fill="#2E75B6" fontWeight="700">vG=Rω</text>
              {/* vTop = 2Rω */}
              <line x1={cx} y1={cy-R} x2={cx+76} y2={cy-R} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#aRed)"/>
              <text x={cx+80} y={cy-R+4} fontSize="11" fill="#c0392b" fontWeight="700">2Rω</text>
            </>
          );
        })()}

        {/* Case 2: Translation — IC at infinity */}
        <rect x={656} y={40} width={228} height={150} rx={4} fill="#fafafa" stroke="#f0cece"/>
        <text x={770} y={58} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Pure Translation</text>
        <text x={770} y={74} textAnchor="middle" fontSize="11" fill="#555" fontStyle="italic">IC at ∞, ω = 0</text>
        {(() => {
          const pts=[[680,120],[780,110],[860,125]];
          return (
            <>
              <rect x={672} y={105} width={212} height={50} rx={5} fill="#2E75B6" stroke="#1a5276" strokeWidth="2" opacity="0.8"/>
              {pts.map(([x,y],i)=>(
                <g key={i}>
                  <line x1={x} y1={y} x2={x+40} y2={y} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#aRed)"/>
                </g>
              ))}
              <text x={770} y={175} textAnchor="middle" fontSize="11" fill="#444">All v arrows parallel</text>
              <text x={770} y={190} textAnchor="middle" fontSize="11" fill="#444">→ IC at infinity</text>
            </>
          );
        })()}

        {/* Summary panel */}
        <rect x={426} y={200} width={458} height={150} rx={4} fill="#fff" stroke="#f0cece"/>
        <text x={655} y={220} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">IC Location Summary</text>

        {[
          {y:230, bg:'#f0fff4', bc:'#27ae60', label:'vA ∥ vB (same direction):',  desc:'IC on perpendicular to v, at intersection of lines through tips/tails'},
          {y:268, bg:'#eaf3ff', bc:'#2E75B6', label:'vA ⊥ vB:',                   desc:'IC at intersection of lines through vA and vB from their respective points'},
          {y:306, bg:'#fff5e6', bc:'#e07b00', label:'Rolling on flat surface:',    desc:'IC at contact point — contact point always has zero velocity'},
          {y:340, bg:'#FEF0F0', bc:'#c0392b', label:'Pure translation:',           desc:'IC at infinity — ω = 0, all points share same velocity'},
        ].map(({y,bg,bc,label,desc})=>(
          <g key={y}>
            <rect x={430} y={y} width={450} height={32} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={436} y={y+13} fontSize="11" fill="#7B0D0D" fontWeight="700">{label}</text>
            <text x={436} y={y+26} fontSize="10" fill="#444">{desc}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The instantaneous centre (IC) is the point about which a rigid body appears to rotate at any given instant. Every velocity can be computed as v = ω × r where r is the distance from the IC to the point. The IC is found by the intersection of perpendiculars to two known velocities. For a rolling wheel the IC is always at the contact point. The IC changes location every instant — it is not a fixed pivot.
      </div>
    </div>
  );
}

// ── Diagram 7: Kinematic Constraints ─────────────────────────────
function DiagConstraints() {
  const W=900, H=420;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Kinematic Constraints — Common Joints, Pairs &amp; Degrees of Freedom</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* Column headers */}
        {['Constraint / Joint','Symbol','DOF removed','DOF remaining','Example'].map((h,i)=>{
          const xs=[10,220,340,460,590];
          const ws=[208,118,118,128,300];
          return (
            <g key={i}>
              <rect x={xs[i]} y={10} width={ws[i]} height={30} fill="#c0392b"/>
              <text x={xs[i]+ws[i]/2} y={29} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{h}</text>
            </g>
          );
        })}

        {/* Table rows */}
        {[
          {
            name:'Pin (revolute) joint\n2D planar',
            dof_rem:2, dof_left:1,
            example:'Hinge, door pivot, elbow joint',
            color:'#2E75B6',
            draw:(x,y)=>(
              <g>
                <line x1={x+10} y1={y+20} x2={x+50} y2={y+20} stroke="#888" strokeWidth="3"/>
                <circle cx={x+50} cy={y+20} r={8} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
                <line x1={x+58} y1={y+20} x2={x+98} y2={y+20} stroke="#888" strokeWidth="3"/>
                <polygon points={`${x+50},${y+32} ${x+42},${y+46} ${x+58},${y+46}`} fill="#888"/>
              </g>
            ),
          },
          {
            name:'Sliding (prismatic)\njoint / slider',
            dof_rem:2, dof_left:1,
            example:'Piston in cylinder, drawer',
            color:'#27ae60',
            draw:(x,y)=>(
              <g>
                <rect x={x+8} y={y+12} width={90} height={16} rx={3} fill="#ddd" stroke="#999" strokeWidth="1.5"/>
                <rect x={x+30} y={y+8} width={36} height={24} rx={4} fill="#27ae60" stroke="#1e8449" strokeWidth="2"/>
                <line x1={x+48} y1={y+8} x2={x+48} y2={y-2} stroke="#c0392b" strokeWidth="2" markerEnd="url(#aRed)"/>
              </g>
            ),
          },
          {
            name:'Fixed (welded)\njoint / rigid',
            dof_rem:3, dof_left:0,
            example:'Welded frame, rigid coupling',
            color:'#c0392b',
            draw:(x,y)=>(
              <g>
                <line x1={x+10} y1={y+20} x2={x+45} y2={y+20} stroke="#888" strokeWidth="3"/>
                <rect x={x+45} y={y+10} width={18} height={20} fill="#c0392b" stroke="#922b21" strokeWidth="2"/>
                <line x1={x+63} y1={y+20} x2={x+98} y2={y+20} stroke="#888" strokeWidth="3"/>
                {[0,4,8,12,16,20].map(oy=>(<line key={oy} x1={x+45} y1={y+10+oy} x2={x+49} y2={y+10+oy+4} stroke="#922b21" strokeWidth="1.2"/>))}
              </g>
            ),
          },
          {
            name:'Rolling contact\n(no slip)',
            dof_rem:2, dof_left:1,
            example:'Rolling wheel, gear teeth',
            color:'#e07b00',
            draw:(x,y)=>(
              <g>
                <circle cx={x+35} cy={y+18} r={18} fill="#f0f0f0" stroke="#e07b00" strokeWidth="2"/>
                <circle cx={x+35} cy={y+18} r={4} fill="#888"/>
                <circle cx={x+72} cy={y+18} r={12} fill="#f0f0f0" stroke="#e07b00" strokeWidth="2"/>
                <circle cx={x+72} cy={y+18} r={3} fill="#888"/>
                <line x1={x+8} y1={y+36} x2={x+100} y2={y+36} stroke="#555" strokeWidth="1.5"/>
              </g>
            ),
          },
          {
            name:'Ball-and-socket\n3D joint',
            dof_rem:3, dof_left:3,
            example:'Hip joint, 3D linkage, shoulder',
            color:'#9b59b6',
            draw:(x,y)=>(
              <g>
                <circle cx={x+50} cy={y+20} r={18} fill="#f5d0ff" stroke="#9b59b6" strokeWidth="2"/>
                <circle cx={x+50} cy={y+20} r={7} fill="#9b59b6"/>
                <line x1={x+5}  y1={y+20} x2={x+32} y2={y+20} stroke="#888" strokeWidth="3"/>
                <line x1={x+68} y1={y+20} x2={x+95} y2={y+20} stroke="#888" strokeWidth="3"/>
              </g>
            ),
          },
          {
            name:'Inextensible string\n/ cable constraint',
            dof_rem:1, dof_left:0,
            example:'Rope over pulley, belt drive',
            color:'#555',
            draw:(x,y)=>(
              <g>
                <circle cx={x+50} cy={y+12} r={12} fill="#ddd" stroke="#888" strokeWidth="2"/>
                <line x1={x+10} y1={y+36} x2={x+44} y2={y+20} stroke="#555" strokeWidth="2"/>
                <line x1={x+56} y1={y+20} x2={x+90} y2={y+36} stroke="#555" strokeWidth="2"/>
                <line x1={x+10} y1={y+36} x2={x+10} y2={y+55} stroke="#555" strokeWidth="2"/>
                <rect x={x+4} y={y+55} width={12} height={14} fill="#2E75B6" stroke="#1a5276" strokeWidth="1.5"/>
                <line x1={x+90} y1={y+36} x2={x+90} y2={y+55} stroke="#555" strokeWidth="2"/>
                <rect x={x+84} y={y+55} width={12} height={14} fill="#c0392b" stroke="#922b21" strokeWidth="1.5"/>
              </g>
            ),
          },
        ].map(({name,dof_rem,dof_left,example,color,draw},ri)=>{
          const ry=46+ri*62;
          const bg=ri%2===0?'#fafafa':'#fff';
          const xs=[10,220,340,460,590];
          const ws=[208,118,118,128,300];

          return (
            <g key={ri}>
              {[0,1,2,3,4].map(ci=>(
                <rect key={ci} x={xs[ci]} y={ry} width={ws[ci]} height={60} fill={bg} stroke="#f0cece" strokeWidth="0.5"/>
              ))}
              {/* Name */}
              {name.split('\n').map((l,li)=>(
                <text key={li} x={16} y={ry+18+li*16} fontSize="11" fill={color} fontWeight={li===0?'700':'400'}>{l}</text>
              ))}
              {/* Symbol drawing */}
              {draw(220, ry+4)}
              {/* DOF removed */}
              <text x={340+59} y={ry+32} textAnchor="middle" fontSize="18" fill="#c0392b" fontWeight="700">{dof_rem}</text>
              {/* DOF remaining */}
              <text x={460+64} y={ry+32} textAnchor="middle" fontSize="18" fill="#27ae60" fontWeight="700">{dof_left}</text>
              {/* Example */}
              <text x={596} y={ry+24} fontSize="10" fill="#444">{example.split(',')[0]}</text>
              {example.split(',')[1] && <text x={596} y={ry+38} fontSize="10" fill="#444">{example.split(',').slice(1).join(',').trim()}</text>}
            </g>
          );
        })}

        {/* Gruebler formula at bottom */}
        <rect x={10} y={424} width={880} height={0} rx={3} fill="none"/>
      </svg>
      <div style={S.dCaption}>
        A kinematic constraint removes one or more degrees of freedom from a body. In 2D, a free body has 3 DOF (x, y, θ). Each constraint type removes a specific number. A pin removes 2 (only rotation remains); a slider removes 2 (only translation along the slot remains); a fixed joint removes all 3. The DOF remaining determines how many independent inputs are needed to fully define the system configuration.
      </div>
    </div>
  );
}

// ── Diagram 8: Gruebler's Equation & 4-Bar Linkage ────────────────
function DiagGruebler() {
  const W=900, H=400;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Grübler's Equation — Degrees of Freedom of Planar Mechanisms</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* ── LEFT: 4-bar linkage ─── */}
        <rect x={10} y={10} width={400} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={210} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">4-Bar Linkage  (DOF = 1)</text>

        {/* Ground link (fixed) */}
        <line x1={70} y1={280} x2={310} y2={280} stroke="#555" strokeWidth="4" strokeLinecap="round"/>
        {[70,90,110,130,150,170,190,210,230,250,270,290,310].map(x=>(<line key={x} x1={x} y1={280} x2={x-10} y2={294} stroke="#555" strokeWidth="1.5"/>))}

        {/* Joints */}
        {(() => {
          const A=[70,280], B=[130,160], C=[280,150], D=[310,280];
          const joints=[A,B,C,D];
          const labels=['A','B','C','D'];
          const colors=['#555','#c0392b','#c0392b','#555'];

          return (
            <>
              {/* Links */}
              <line x1={A[0]} y1={A[1]} x2={B[0]} y2={B[1]} stroke="#2E75B6" strokeWidth="5" strokeLinecap="round"/>
              <line x1={B[0]} y1={B[1]} x2={C[0]} y2={C[1]} stroke="#e07b00" strokeWidth="5" strokeLinecap="round"/>
              <line x1={C[0]} y1={C[1]} x2={D[0]} y2={D[1]} stroke="#27ae60" strokeWidth="5" strokeLinecap="round"/>

              {/* Link labels */}
              <text x={(A[0]+B[0])/2-22} y={(A[1]+B[1])/2} fontSize="12" fill="#2E75B6" fontWeight="700">crank</text>
              <text x={(B[0]+C[0])/2}    y={(B[1]+C[1])/2-10} fontSize="12" fill="#e07b00" fontWeight="700">coupler</text>
              <text x={(C[0]+D[0])/2+5}  y={(C[1]+D[1])/2} fontSize="12" fill="#27ae60" fontWeight="700">rocker</text>
              <text x={(A[0]+D[0])/2}    y={A[1]+18} textAnchor="middle" fontSize="12" fill="#555" fontWeight="700">ground</text>

              {/* Pin joints */}
              {joints.map(([x,y],i)=>(
                <g key={i}>
                  <circle cx={x} cy={y} r={9} fill={colors[i]} stroke="#fff" strokeWidth="2"/>
                  <text x={x+(i<2?-16:10)} y={y+(i===0||i===3?16:-10)} fontSize="13" fill={colors[i]} fontWeight="700">{labels[i]}</text>
                </g>
              ))}

              {/* DOF indicators */}
              <text x={210} y={320} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">n=4 links, j=4 joints (all pin)</text>
              <text x={210} y={340} textAnchor="middle" fontSize="13" fill="#c0392b" fontFamily="'Courier New',monospace">DOF = 3(n−1) − 2j₁ − j₂</text>
              <text x={210} y={358} textAnchor="middle" fontSize="13" fill="#c0392b" fontFamily="'Courier New',monospace">    = 3(3) − 2(4) − 0 = 1</text>
              <text x={210} y={376} textAnchor="middle" fontSize="12" fill="#555">One input → fully defined motion</text>
            </>
          );
        })()}

        {/* ── RIGHT: formula & examples ─── */}
        <rect x={420} y={10} width={470} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={655} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Grübler's Formula &amp; Examples</text>

        {/* Formula box */}
        <rect x={426} y={40} width={458} height={72} rx={4} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={655} y={60} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">M = 3(n − 1) − 2j₁ − j₂</text>
        <text x={432} y={80} fontSize="11" fill="#444">M = mobility (DOF),  n = number of links (inc. ground)</text>
        <text x={432} y={96} fontSize="11" fill="#444">j₁ = full joints (pin, slider — remove 2 DOF each)</text>
        <text x={432} y={110} fontSize="11" fill="#444">j₂ = half joints (rolling, cable — remove 1 DOF each)</text>

        {/* Examples table */}
        {[
          {y:124, bg:'#eaf3ff', bc:'#2E75B6', name:'Crank-slider (engine)',   n:4, j1:4, j2:0, M:1, note:'1 input (crank) → piston moves'},
          {y:174, bg:'#f0fff4', bc:'#27ae60', name:'5-bar linkage',            n:5, j1:5, j2:0, M:2, note:'2 inputs needed'},
          {y:224, bg:'#fff5e6', bc:'#e07b00', name:'Watt\'s 6-bar linkage',   n:6, j1:7, j2:0, M:1, note:'Complex single-DOF mechanism'},
          {y:274, bg:'#f5d0ff', bc:'#9b59b6', name:'Locked mechanism (truss)',n:4, j1:5, j2:0, M:-2,note:'Over-constrained (rigid)'},
          {y:324, bg:'#FEF0F0', bc:'#c0392b', name:'Structure (triangle)',     n:3, j1:3, j2:0, M:0, note:'Statically determinate frame'},
        ].map(({y,bg,bc,name,n,j1,j2,M,note})=>(
          <g key={y}>
            <rect x={426} y={y} width={458} height={46} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={432} y={y+16} fontSize="12" fill="#7B0D0D" fontWeight="700">{name}</text>
            <text x={432} y={y+32} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">n={n}, j₁={j1}, j₂={j2}  →  M = 3({n}-1)-2×{j1} = {M}</text>
            <text x={432} y={y+44} fontSize="10" fill="#666" fontStyle="italic">{note}</text>
          </g>
        ))}

        {/* Interpretation */}
        <rect x={426} y={374} width={458} height={20} rx={3} fill="#1a1a2e" opacity="0.06"/>
        <text x={655} y={388} textAnchor="middle" fontSize="11" fill="#555">M&gt;0: mobile mechanism  |  M=0: structure  |  M&lt;0: over-constrained</text>
      </svg>
      <div style={S.dCaption}>
        Grübler's (Kutzbach) equation M = 3(n−1) − 2j₁ − j₂ counts the mobility of a planar mechanism. A 4-bar linkage has exactly M=1 — one input (crank angle) completely determines all other positions. M=0 gives a rigid structure (truss). M&lt;0 means over-constrained (redundant constraints, as in a locked mechanism). M&gt;1 means more inputs are needed, as in a robot arm with multiple actuators.
      </div>
    </div>
  );
}

// ── Diagram 9: Constraint Equations — Rope/Pulley Systems ─────────
function DiagConstraintEquations() {
  const W=900, H=380;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Constraint Equations — Rope &amp; Pulley Systems</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* ── LEFT: Simple Atwood machine ─── */}
        <rect x={10} y={10} width={260} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={135} y={30} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Simple Atwood Machine</text>

        {/* Fixed pulley */}
        <circle cx={135} cy={75} r={20} fill="#ddd" stroke="#888" strokeWidth="2"/>
        <circle cx={135} cy={75} r={6} fill="#555"/>
        <line x1={115} y1={50} x2={155} y2={50} stroke="#888" strokeWidth="2"/>
        {/* Rope */}
        <line x1={115} y1={75} x2={115} y2={200} stroke="#555" strokeWidth="2.5"/>
        <line x1={155} y1={75} x2={155} y2={220} stroke="#555" strokeWidth="2.5"/>
        {/* Masses */}
        <rect x={95} y={200} width={40} height={40} rx={4} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <text x={115} y={225} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">m₁</text>
        <rect x={135} y={220} width={40} height={40} rx={4} fill="#c0392b" stroke="#922b21" strokeWidth="2"/>
        <text x={155} y={245} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">m₂</text>
        {/* x1, x2 labels */}
        <line x1={82} y1={75} x2={82} y2={220} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="4" markerEnd="url(#aBlue)"/>
        <text x={68} y={155} fontSize="12" fill="#2E75B6" fontWeight="700">x₁</text>
        <line x1={178} y1={75} x2={178} y2={240} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="4" markerEnd="url(#aRed)"/>
        <text x={184} y={165} fontSize="12" fill="#c0392b" fontWeight="700">x₂</text>

        <rect x={16} y={278} width={248} height={90} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={22} y={296} fontSize="12" fill="#7B0D0D" fontWeight="700">Constraint (inextensible rope):</text>
        <text x={22} y={314} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">x₁ + x₂ = L  (constant)</text>
        <text x={22} y={332} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">ẋ₁ + ẋ₂ = 0  →  v₁ = −v₂</text>
        <text x={22} y={350} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">ẍ₁ + ẍ₂ = 0  →  a₁ = −a₂</text>
        <text x={22} y={366} fontSize="11" fill="#555">One DOF: only x₁ independent</text>

        {/* ── MIDDLE: Compound pulley ─── */}
        <rect x={280} y={10} width={280} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={420} y={30} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Compound Pulley System</text>

        {/* Fixed support */}
        <line x1={300} y1={55} x2={540} y2={55} stroke="#555" strokeWidth="3"/>
        {[300,320,340,360,380,400,420,440,460,480,500,520,540].map(x=>(<line key={x} x1={x} y1={55} x2={x-10} y2={68} stroke="#555" strokeWidth="1.5"/>))}

        {/* Fixed pulley at top */}
        <circle cx={350} cy={95} r={18} fill="#ddd" stroke="#888" strokeWidth="2"/>
        <circle cx={350} cy={95} r={5} fill="#555"/>
        <line x1={338} y1={55} x2={338} y2={77} stroke="#555" strokeWidth="2"/>

        {/* Moving pulley (attached to mass m₂) */}
        <circle cx={420} cy={220} r={18} fill="#f0f0f0" stroke="#e07b00" strokeWidth="2"/>
        <circle cx={420} cy={220} r={5} fill="#888"/>

        {/* Ropes */}
        <line x1={332} y1={95} x2={332} y2={220} stroke="#555" strokeWidth="2.5"/>
        <line x1={368} y1={95} x2={368} y2={200} stroke="#555" strokeWidth="2.5"/>
        {/* rope from fixed pulley to effort */}
        <line x1={368} y1={95} x2={420} y2={95} stroke="#555" strokeWidth="2.5"/>
        <line x1={420} y1={95} x2={420} y2={202} stroke="#555" strokeWidth="2.5"/>
        {/* Rope segment on other side of moving pulley */}
        <line x1={402} y1={220} x2={402} y2={280} stroke="#555" strokeWidth="2.5"/>

        {/* Effort (applied force) */}
        <line x1={332} y1={220} x2={332} y2={280} stroke="#555" strokeWidth="2.5"/>

        {/* Mass m₂ hanging from moving pulley */}
        <rect x={400} y={240} width={40} height={40} rx={4} fill="#c0392b" stroke="#922b21" strokeWidth="2"/>
        <text x={420} y={265} textAnchor="middle" fontSize="14" fill="#fff" fontWeight="700">m₂</text>

        {/* Mass m₁ / effort */}
        <rect x={310} y={280} width={40} height={40} rx={4} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <text x={330} y={305} textAnchor="middle" fontSize="14" fill="#fff" fontWeight="700">F</text>

        <rect x={286} y={330} width={268} height={40} rx={3} fill="#fff5e6" stroke="#e07b00" strokeWidth="1.5"/>
        <text x={292} y={348} fontSize="11" fill="#7B0D0D" fontWeight="700">Constraint: 2x₂ + x_F = L</text>
        <text x={292} y={364} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">v_F = 2v₂   |   a_F = 2a₂</text>

        {/* ── RIGHT: General constraint examples ─── */}
        <rect x={570} y={10} width={320} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={730} y={30} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Constraint Types &amp; Methods</text>

        {[
          {y:40,  bg:'#f0fff4', bc:'#27ae60', label:'Geometric constraint',
           lines:['Rigid rod of length L:', 'x_A² + y_A² = L² (pendulum)', 'Eliminates one DOF', '→ only θ is independent']},
          {y:116, bg:'#FEF0F0', bc:'#c0392b', label:'Velocity constraint',
           lines:['No-slip rolling:', 'v_contact = 0', 'vG = Rω  (link translational & angular)', 'Differentiating geometric constraint']},
          {y:192, bg:'#eaf3ff', bc:'#2E75B6', label:'Rope/cable constraint',
           lines:['Σ(rope segments) = L', 'Differentiate → velocity relation', 'Differentiate → acceleration relation', 'Used in pulley systems, cranes']},
          {y:268, bg:'#fff5e6', bc:'#e07b00', label:'Gear constraint',
           lines:['r₁θ₁ = −r₂θ₂  (external gears)', 'ω₁r₁ = ω₂r₂', 'Pitch-circle contact: no-slip', 'α₁r₁ = α₂r₂']},
          {y:328, bg:'#f5d0ff', bc:'#9b59b6', label:'Constraint counting',
           lines:['n free bodies → 3n DOF (2D)', 'Each constraint eqn removes 1 DOF', 'DOF = 3n − #constraints', 'Must equal Grübler result']},
        ].map(({y,bg,bc,label,lines})=>(
          <g key={y}>
            <rect x={576} y={y} width={308} height={lines.length*16+24} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={582} y={y+16} fontSize="12" fill="#7B0D0D" fontWeight="700">{label}</text>
            {lines.map((l,i)=><text key={i} x={582} y={y+32+i*16} fontSize="10" fill="#444" fontFamily={i>0?"'Courier New',monospace":'inherit'}>{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Kinematic constraints are equations that relate the positions (and by differentiation, the velocities and accelerations) of different parts of a system. For rope-and-pulley systems, the total rope length is constant — differentiating once gives a velocity relationship, twice gives an acceleration relationship. Each independent constraint equation reduces the system's degrees of freedom by one. For the compound pulley, the velocity advantage is 2: the load moves half as fast as the effort.
      </div>
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────────────
export default function SystemKinematics() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>System Kinematics</h1>
       
      <p style={S.p}>
        Kinematics is the study of motion — displacement, velocity, and acceleration — without reference to the forces that cause it. It is the geometric language of dynamics: before writing any equation of motion, we must know how every part of the system moves and how those motions are related. This page covers kinematics of particles (in 1D and curvilinear motion), rigid bodies (translation, rotation, and general planar motion), relative motion between two points on a body, and kinematic constraints that link the degrees of freedom of a mechanism.
      </p>
<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <img src={Kinematics2} alt="linkages" width="75%"/>
                                </div>
      <InfoBox title="Core Ideas at a Glance" items={[
        "v = dx/dt = ẋ  |  a = dv/dt = ẍ  |  integrate to go backwards: x = ∫v dt,  v = ∫a dt",
        "Curvilinear: Cartesian (x,y) — independent components; Polar (r,θ) — includes Coriolis 2ṙθ̇; N-T (n,t) — separates speed change from direction change",
        "Rigid body: all points share the same angular velocity ω and angular acceleration α",
        "vB = vA + ω × r(B/A)  |  aB = aA + α×r(B/A) − ω²r(B/A)",
        "Instantaneous centre (IC): point of zero velocity — every velocity = ω × r from IC",
        "Rolling without slip: vG = Rω, contact point velocity = 0, IC at contact",
        "Grübler: M = 3(n−1) − 2j₁ − j₂  (mobility of planar mechanism)",
        "Constraint equations: differentiate geometric/rope relations to get velocity and acceleration constraints",
      ]}/>

      <h2 style={S.h2}>Displacement, Velocity &amp; Acceleration Relationships</h2>
      <p style={S.p}>
        The three kinematic quantities — displacement x, velocity v, and acceleration a — are connected by the differential calculus. Velocity is the time-derivative of displacement; acceleration is the time-derivative of velocity. Moving in the opposite direction (integration) recovers displacement from velocity and velocity from acceleration, subject to initial conditions. For constant acceleration these relationships produce the well-known SUVAT equations. For variable acceleration (the general case in dynamics) the full differential or integral must be used.
      </p>
      <DiagDVA/>
      <Table2 rows={[
        ["Velocity","v = dx/dt = ẋ\nInstantaneous rate of change of position\nSlope of the x–t graph at any point"],
        ["Acceleration","a = dv/dt = d²x/dt² = ẍ\nRate of change of velocity\nSlope of the v–t graph; second derivative of x"],
        ["Integration","x(t) = x₀ + ∫₀ᵗ v dt   |   v(t) = v₀ + ∫₀ᵗ a dt\nArea under v–t curve = displacement\nArea under a–t curve = velocity change"],
        ["SUVAT (const. a)","v = u + at\ns = ut + ½at²\nv² = u² + 2as\ns = ½(u+v)t"],
        ["Jerk  j","j = da/dt = d³x/dt³   [m/s³]\nRelevant for ride comfort, robot path planning, cam design\nHigh jerk causes vibration and wear"],
        ["Practical note","Real signals: differentiation amplifies noise; prefer integration\nAccelerometers measure a(t) → integrate to get v(t) then x(t)\nGPS measures x(t) → differentiate to get v(t)"],
      ]}/>

      <h2 style={S.h2}>Curvilinear Motion — Coordinate Systems</h2>
      <p style={S.p}>
        When motion is not along a straight line, we must choose a coordinate system suited to the geometry. Three systems are common: Cartesian (x, y) — simple but components may not be independent physically; Polar (r, θ) — natural for orbital or rotating-arm problems, but introduces the Coriolis acceleration 2ṙθ̇ when r changes while rotating; Normal-Tangential (n, t) — tied to the path itself, naturally separating the change of speed from the change of direction.
      </p>
      <DiagCurvilinear/>
      <Table2 rows={[
        ["Cartesian velocity","v = ẋî + ẏĵ\n|v| = √(ẋ²+ẏ²)\nSimplest; use when x, y are the natural unknowns"],
        ["Polar velocity","v = ṙ êᵣ + rθ̇ êθ\nRadial component ṙ = change in radius\nTransverse component rθ̇ = tangential speed"],
        ["Polar acceleration","a = (r̈ − rθ̇²) êᵣ + (rθ̈ + 2ṙθ̇) êθ\n−rθ̇² = centripetal (inward)\n2ṙθ̇ = Coriolis (appears only when ṙ ≠ 0)"],
        ["N-T velocity","v = v êₜ   (always along path, no normal component)\nMagnitude = speed v; direction = tangent to path"],
        ["N-T acceleration","a = v̇ êₜ + (v²/ρ) êₙ\nTangential: v̇ = dv/dt (speed change)\nNormal: v²/ρ = centripetal (direction change); ρ = radius of curvature"],
        ["Radius of curvature ρ","ρ = [1+(dy/dx)²]^{3/2} / |d²y/dx²|\nFor circle of radius R: ρ = R everywhere\nFor straight line: ρ = ∞ (no centripetal acceleration)"],
      ]}/>

      <h2 style={S.h2}>Rigid Body Kinematics</h2>
      <p style={S.p}>
        A rigid body is one in which the distance between any two points remains constant — it does not deform. In planar (2D) motion, a rigid body has three degrees of freedom: two translational (x_G, y_G of the centre of mass) and one rotational (θ). The key property is that all points on the body share the same angular velocity ω and angular acceleration α, even though their linear velocities and accelerations differ depending on their distance from the reference point.
      </p>
      <DiagRigidBody/>
      <DiagAngularKinematics/>
      <Table2 rows={[
        ["Pure translation","All points: same v, same a\nAngular velocity ω = 0\nNo rotation — body moves as a particle"],
        ["Pure rotation (fixed axis)","v = rω  (tangential, ⊥ to radius)\naₙ = rω² (centripetal, toward axis)\naₜ = rα  (tangential, along path)\n|a| = r√(ω⁴+α²)"],
        ["General planar motion","Superposition: translation of G + rotation about G\nvB = vG + ω × r(B/G)\naB = aG + α × r(B/G) − ω² r(B/G)"],
        ["Angular velocity ω","ω = dθ/dt   [rad/s]\nPositive: counterclockwise (standard)\nShared by all points on the rigid body"],
        ["Angular acceleration α","α = dω/dt = d²θ/dt²   [rad/s²]\nConstant α: same SUVAT equations as linear motion\nω₀,  ω = ω₀ + αt,  θ = θ₀ + ω₀t + ½αt²"],
        ["Rolling without slip","Contact point C has zero velocity\nvG = Rω   (geometric constraint)\naG = Rα  (if roll is pure — no slip)"],
      ]}/>

      <h2 style={S.h2}>Relative Motion</h2>
      <p style={S.p}>
        Relative motion analysis allows us to find the velocity and acceleration of any point on a rigid body if we already know the motion of any other point on the same body, together with the angular velocity ω and angular acceleration α. The relative velocity v_rel = ω×r is always perpendicular to the line joining the two points and has magnitude ωr. The relative acceleration has two components: the centripetal part ω²r directed inward along the link (always known), and the tangential part αr perpendicular to the link (unknown if α is unknown).
      </p>
      <DiagRelativeMotion/>
      <Table2 rows={[
        ["Velocity equation","vB = vA + ω × r(B/A)\nScalar 2D: vBx = vAx − ω·y(B/A)\n           vBy = vAy + ω·x(B/A)\nv(B/A) always ⊥ to line AB"],
        ["Acceleration equation","aB = aA + α×r(B/A) − ω²r(B/A)\n= aA + (a(B/A))ₜ + (a(B/A))ₙ\nNormal component direction always known (toward A)"],
        ["Tangential relative accel.","(a(B/A))ₜ = αr,  direction ⊥ AB\nUnknown magnitude if α unknown\nProvides one additional equation"],
        ["Normal relative accel.","(a(B/A))ₙ = ω²r,  direction from B toward A\nAlways completely known — no unknowns\nDoes not help solve for unknowns directly"],
        ["Two-point method","Known: position of A, vA, ω\nUnknown: vB (direction or magnitude)\nEquation vB = vA + ω×r provides 2 scalar eqns, 2 unknowns"],
        ["Acceleration count","With known ω, α, aA: aB fully determined\nWith unknown α: aB = aA + αr(perp) + ω²r(toward A)\n3 unknowns max solvable with 2 equations from x,y components"],
      ]}/>

      <h2 style={S.h2}>Instantaneous Centre of Zero Velocity</h2>
      <DiagInstantCentre/>
      <Table2 rows={[
        ["IC definition","Point on (or extended from) the body with zero velocity at that instant\nAll other velocities = ω × r from IC to the point\nIC is not fixed — it moves as the mechanism moves"],
        ["Finding the IC","Draw perpendiculars to vA and vB\nIC is where they intersect\nIf vA ∥ vB: IC on line through tips/tails proportionally"],
        ["Velocity from IC","v = ω × r  where r = distance from IC to the point\nvA/vB = rA/rB  (velocities proportional to distances from IC)"],
        ["Rolling wheel","IC at contact point with ground (zero velocity there)\nvG = Rω,  v_top = 2Rω  (top moves twice as fast as centre)"],
        ["Pure translation","IC at infinity — perpendiculars to parallel velocities never meet\nω = 0, consistent with no rotation"],
        ["Limits of IC method","Works only for velocities (not directly for accelerations)\nFor accelerations, use relative motion or acceleration diagram method"],
      ]}/>

      <h2 style={S.h2}>Kinematic Constraints</h2>
      <p style={S.p}>
        Every joint, contact pair, or inextensible connection imposes constraints that reduce the number of independent motions (degrees of freedom) in a system. Understanding the type of constraint tells us both how many DOF are removed and what kinematic relationships must be satisfied. The Grübler equation counts the total mobility of a mechanism from the number of links and joints alone.
      </p>
      <DiagConstraints/>
      <DiagGruebler/>
      <DiagConstraintEquations/>
      <Table2 rows={[
        ["Degree of freedom (DOF)","Number of independent coordinates needed to fully describe configuration\n2D free body: 3 DOF (x, y, θ)\n3D free body: 6 DOF (3 translational, 3 rotational)"],
        ["Pin joint (2D)","Removes 2 DOF (fixes x and y of common point)\nLeaves 1 DOF (relative rotation θ)\nMost common joint in planar mechanisms"],
        ["Prismatic joint (slider)","Removes 2 DOF (relative rotation + one translation)\nLeaves 1 DOF (sliding along the slot direction)\nUsed in pistons, linear actuators"],
        ["Grübler's equation","M = 3(n−1) − 2j₁ − j₂\nn = total links (including ground)\nj₁ = full joints (pin, slider);  j₂ = half joints (rolling)"],
        ["Geometric constraint","Write position relationship (rope length, rigid distance)\nDifferentiate once: velocity constraint\nDifferentiate twice: acceleration constraint"],
        ["Rolling constraint","v_contact = 0  (no-slip condition)\nv_centre = R·ω  (tangential velocity at rim = 0 at contact)\nLinks translational and rotational DOF — removes 1 DOF"],
        ["Gear constraint","r₁ω₁ = −r₂ω₂  (external mesh, opposite rotations)\nAlpha: r₁α₁ = −r₂α₂\nGear ratio n = ω₂/ω₁ = r₁/r₂ = N₁/N₂"],
        ["Holonomic vs non-holonomic","Holonomic: constraint expressible in terms of positions only\nNon-holonomic: involves velocities not integrable to positions\nExample: rolling disc on plane is non-holonomic in 3D"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "1D kinematics:  v = ẋ,  a = ẍ  |  SUVAT:  v=u+at,  s=ut+½at²,  v²=u²+2as",
        "Polar:  v = ṙêᵣ + rθ̇êθ  |  a = (r̈−rθ̇²)êᵣ + (rθ̈+2ṙθ̇)êθ",
        "N-T:  v = vêₜ  |  a = v̇êₜ + (v²/ρ)êₙ",
        "Angular:  ω = θ̇,  α = θ̈  |  v = rω,  aₙ = rω²,  aₜ = rα",
        "Rigid body relative motion:  vB = vA + ω×r(B/A)",
        "Rigid body relative accel.:  aB = aA + α×r(B/A) − ω²r(B/A)",
        "Rolling without slip:  vG = Rω,  aG = Rα,  v_contact = 0",
        "IC method:  v = ω·r (r from IC)  |  vA/vB = rA/rB",
        "Grübler:  M = 3(n−1) − 2j₁ − j₂",
        "Rope constraint:  Σ(lengths) = const → differentiate for velocity, acceleration",
      ]}/>
    </div>
  );
}